import { LINK_FIELD } from './elements/link'
import { LINK_TITLE } from './elements/link'

export const HEADER = `
navigation: entries(
  section: "headerNavigation",
  site: $site,
  level: 1
) {
  __typename
  title
  typeHandle
  id


  
  ...on dropdownColumns_Entry {
    id
    typeHandle
    title
    children {
      id
      typeHandle
      title
      children {
        id
        typeHandle
        title
        children {
          id
          typeHandle
          title
          linkField {
            url
          }
        }
      }
    }
  }
    

  ...on navButton_Entry {
    title
    popupEnabled
    popupFormId

    ${ LINK_FIELD }
  }

  ...on navItem_Entry {
    ${ LINK_FIELD }
  }

  ...on productsDropdown_Entry {
    id
    headingLeftSide
    headingRightSide
    headingLeftBottom
    headingRightBottom
    linkRightBottom {
      url
    }
  }

  children {
    id
    title
    __typename
    typeHandle

    ...on navItem_Entry {
      iconField {
        url
        title
      }
      ${ LINK_FIELD }
    }


    ...on column_Entry {
      children {
        id
        title
        __typename
        typeHandle
        ...on navItem_Entry {
          iconField {
            url
            title
          }
          subtitle
          text
          description
          ${ LINK_FIELD }
        }
      }
    }


    ...on leftSide_Entry {
      iconField {
        url
        title
      }
      text
      ${ LINK_FIELD }
    }

    ...on leftBottom_Entry {
      iconField {
        url
        title
      }
      ${ LINK_FIELD }
    }

    ...on rightSide_Entry {
      image {
        url
        title
      }
      cardTitle
      cardDescription
      ${ LINK_TITLE }
    }

    ...on rightBottom_Entry {
      iconField {
        url
        title
      }
      ${ LINK_FIELD }
    }
    
  }
}
`